<template lang="pug">
  .adsuccess
    .ad(@click="toLink")
      img(src="../../../public/images/200G.png")
      el-button.btn-submit 点 击 立 即 领 取
</template>

<script>
export default {
  methods: {
    toLink() {
      location.href = 'https://vxpage.niceblu.com/self.html#/card/hmcard?channel=alipayself';
    }
  }
}
</script>

<style lang="less" scoped>
.adsuccess{
  background: url('../../../public/images/bg.png') center top no-repeat;
  background-size: 100%;
  min-height: 600px;
  padding-top: 240px;
  background-color: #f8b467;
}
.ad{
  width: 70%;
  margin: 0 auto;
  background: #fff;
  padding: .5rem;
  border-radius: 6px;
  img{
    width: 100%;
  }
  .btn-submit{
    width: 100%;
    background-color: #ff810b;
    color: #fff;
    border: 0;
    margin-top: 10px;
    font-size: 1rem;
  }
}
</style>